export const TOKEN_KEY = 'auth-token';
export const REFRESHTOKEN_KEY = 'auth-refreshtoken';
export const USER_KEY = 'auth-user';
export const TEMP_TOKEN_KEY = 'temp-token';
export const SECRET_KEY = 'secret-key';
export const EMPLOYEE_ID_KEY = 'auth-employee-id';
export const SAVED_ROUTE_KEY = 'saved-route';
export const LANG_KEY = 'lang';
